export const domainConstants = {
  CREATE_DOMAIN: "CREATE_DOMAIN",
  UPDATE_DOMAIN: "UPDATE_DOMAIN",
  GET_DOMAIN: "GET_DOMAIN",
  DELETE_DOMAIN: "DELETE_DOMAIN",
  STORE_DOMAIN: "STORE_DOMAIN",
};
